import React from "react";

const TrackItem = ({
  race,
  track,
  setSelectOption,
  selectOption,
  getEntriesRace,
}) => {
  let classLi = "";
  if (selectOption.raceID === race.RaceID) {
    classLi = "active";
  }
  let status;

  //MTP
  const getTimeInfo = (time) => {
    var postTime = new Date(time);
    return (
      ("0" + postTime.getHours()).slice(-2) +
      ":" +
      ("0" + postTime.getMinutes()).slice(-2)
    );
  };

  //Agrega los estados del race según corresponda
  if (race) {
    switch (race.RaceStatus) {
      case "O":
        if (race.MTP === -128) {
          status = (
            <span style={{ fontSize: "14px", marginLeft: "60px" }}>
              {getTimeInfo(race.SystemRaceDateTime)}
            </span>
          );
        } else if (race.MTP === 0) {
          status = (
            <span
              className="badge badge-pill"
              style={{ backgroundColor: "#17a2b8", color: "#fff" }}
            >
              Post
            </span>
          );
        } else if (race.MTP > 0) {
          status = (
            <span style={{ fontSize: "14px", marginLeft: "60px" }}>
              {race.MTP} m
            </span>
          );
        }
        break;
      case "B":
        status = <span className="badge badge-pill badge-danger">Off</span>;
        break;
      case "C":
        status = (
          <span className="badge badge-pill badge-success">Complete</span>
        );
        break;
      case "X":
        status = (
          <span
            className="badge badge-pill"
            style={{ backgroundColor: "#660000", color: "#fff" }}
          >
            Cancelled
          </span>
        );
        break;
      default:
    }
  }

  //Carga los entries para cada carrera
  const getEntries = (RaceID, raceStatus) => {
    setSelectOption(
      track.TrackID,
      track.TrackName,
      race.RaceID,
      race.RaceNumber,
      track.TrackCode,
      raceStatus
    );

    getEntriesRace(RaceID, 0, raceStatus);
  };

  return (
    <li key={selectOption.raceID} className={classLi}>
      <a
        className="mr-3"
        onClick={() => getEntries(race.RaceID, race.RaceStatus)}
      >
        <div
          style={{
            display: "inline-block",
          }}
        ></div>
        R{race.RaceNumber}
        <span style={{ float: "right" }}>{status}</span>
      </a>
    </li>
  );
};

export default TrackItem;
